import { FaturaonaylaPage } from './../faturaonayla/faturaonayla';
import { AlisFaturalariPage } from './../alis-faturalari/alis-faturalari';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Ortak } from './../../../providers/ortak';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { BllSiparisDetay } from './../../../providers/bll/bll-siparis-detay';
import { Component } from '@angular/core';
import { NavController, NavParams, Platform } from 'ionic-angular';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { SatisFaturaListesiPage } from '../satis-fatura-listesi/satis-fatura-listesi';
import { NL_Siparis } from '../../../models/NL_Siparis';
import { PerakendeSatisFaturalariPage } from '../perakende-satis-faturalari/perakende-satis-faturalari';

@Component({
  selector: 'page-ozet',
  templateUrl: 'ozet.html',
})
export class OzetPage {
  onaylaPasif: boolean = false;
  faturaToplamTutar: number = 0;
  siparisDetaylari = [];
  cariid: number = 0;
  aktifkullaniciadi = "";
  sipID:number=0;
  gidenmethoadi = "";
  faturatip: number = 0;//1 ise satış 2 ise alış faturası
  faturaozellikleri: any = { CariID: "", ToplamTutar: "", Method: "" };
  constructor(public platform: Platform,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public ortak: Ortak,
    public bllOrtak: BllOrtak,
    public modalCtrl: ModalController,
    public view: ViewController) {
    this.aktifkullaniciadi = this.ortak.aktifKullaniciAdi;
    if (navParams.get("faturatip") != null) {
      this.faturatip = navParams.get("faturatip");
      if (this.faturatip == 1)
      {
        this.gidenmethoadi = "SatisFatKaydet";
        this.sipID=-995;
      } 
      if (this.faturatip == 2)
      {
        this.gidenmethoadi = "AlisFatKaydet";
        this.sipID=-994;
      } 
      if (this.faturatip == 3)
      {
        this.gidenmethoadi = "PerakendeFatKaydet";
        this.sipID=-993;
      } 
    }


  }

  ionViewDidLoad() {
    this.siparisDetayListesi_Temp();
  }

  siparisDetayListesi_Temp() {
    this.faturaToplamTutar = 0;

    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll({ siparisID: this.sipID }).then(a => {
      var sonuc = <any>a;
      console.log(this.sipID)
      this.siparisDetaylari = sonuc;

      if (this.siparisDetaylari.length <= 0) {
        this.onaylaPasif = true;
      }
      this.siparisDetaylari.forEach(item => {
        this.faturaToplamTutar += item.Tutar;
        this.cariid = item.CariKartID;
      })
    })
  }

  MiktarGuncelle(detay) {
    if (detay.SIPARIS_DURUM_ID == 255) {
      this.ortak.alertSiparisKalemGuncelle(detay).then(a => {
        var sonuc = <any>a;
        var values = sonuc.values;
        console.log("ddd",detay)
        if (values.miktar==null || values.miktar=="") 
        {
         values.miktar=1;

        }
        if (values.fiyat==null || values.fiyat=="") 
        {
         values.fiyat=1;

        }
        if(values.miktar!=null||values.fiyat!=null)
        {
          var siparisDetay = new NL_Siparis();
    
          siparisDetay.Miktar = values.miktar;
          siparisDetay.BirimFiyat = values.fiyat;
          siparisDetay.Tutar = values.miktar * values.fiyat*(1+(detay.KdvOran/100));
          
          siparisDetay.NetFiyat= siparisDetay.Tutar;
          siparisDetay.AraTutar=values.fiyat*values.miktar;
          siparisDetay.ID = detay.ID;
          siparisDetay.Kdv=           siparisDetay.Tutar -         siparisDetay.AraTutar
          siparisDetay.DovizTip=siparisDetay.DovizTip;
 
          var bllSiparisDetay = new BllSiparisDetay();

          console.log("kkkk",siparisDetay)
          // bllSiparisDetay.miktarGuncelle(siparisDetay).then(a => {
            bllSiparisDetay.birimFiyatGuncelle(siparisDetay).then(b => {
             
              this.siparisDetayListesi_Temp();
     
            });
        //  });
        
        }
     
  
        
      });
    }
  }
  kalemSil(detay) {
    var bllSiparisDetay = new BllSiparisDetay();
    if (detay.SIPARIS_DURUM_ID == 255) {
      bllSiparisDetay.delete({ ID: detay.ID }).then(a => {
        this.siparisDetayListesi_Temp();
      }).then(c => {
      })
    }
  }
  onayla() {

    this.faturaozellikleri.CariID = this.cariid;
    this.faturaozellikleri.Method = this.gidenmethoadi;
    this.faturaozellikleri.ToplamTutar = this.faturaToplamTutar;
    let modal = this.modalCtrl.create(FaturaonaylaPage, { Fatura: this.faturaozellikleri });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    })
    modal.present();
  }



  kapat() {
    this.viewCtrl.dismiss();
  }
  anasayfayadon() {

    if (this.faturatip == 1) this.navCtrl.push(SatisFaturaListesiPage);
    if (this.faturatip == 2) this.navCtrl.push(AlisFaturalariPage);
    if (this.faturatip == 3) this.navCtrl.push(PerakendeSatisFaturalariPage);

  }
  cacheTemizle() {
    this.ortak.showConfirmAlert("Uyarı", "Fatura içeriği temizlenecek devam etmek istiyormusunuz").then(k => {
    
      this.onaylaPasif = true;
      var bllSiparisDetay = new BllSiparisDetay();
      bllSiparisDetay.execRawQuery("DELETE FROM NL_Siparis WHERE siparisID = " + this.sipID).then(b => {
        this.siparisDetayListesi_Temp();
        this.onaylaPasif = true;
      }).catch(x => {
        console.log(x);
      })
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/ozet/ozet.ts